module.exports = __webpack_public_path__ + "static/media/info-button (1).394d8986.svg";